import React, { PropsWithChildren } from 'react';
import { Container } from './style';

const PaymentContainer = ({ children }: PropsWithChildren<any>) => (
  <Container data-testid="cmp-payment-container">{children}</Container>
);

export default PaymentContainer;
